import script from "./Layout.vue?vue&type=script&setup=true&lang=js"
export * from "./Layout.vue?vue&type=script&setup=true&lang=js"

import "./Layout.vue?vue&type=style&index=0&id=6406cca7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6406cca7"]])

export default __exports__